




// doc: https://github.com/kaorun343/vue-property-decorator
import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/utils/ViewBase'

@Component
export default class Upload extends ViewBase {
  @Prop({ type: String, default: ''}) value!: string
  @Prop({ type: String, default: ''}) placeholder!: string

  done() {
    this.$emit('input', this.value)
  }
}
